import {ActivityIndicator, View} from "react-native";
import React from "react";

import {styles} from "./styles";

export const ActivityIndicatorView = ({isVisible, color = "white"}) => {
    let style = styles.activityIndicatorContainer;
    if (color !== "white") {
        style = styles.whiteActivityIndicatorContainer;
    }

    return isVisible ?
        <View style={style}>
            <ActivityIndicator size="large" color={color} />
        </View>
        :
        <></>
}
